/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

import Config from '@/config'
import { restWithCache } from '@/store/lib/search'
import HttpProvider from '@/services/HttpProvider'
import Vue from 'vue'
import Blog from '@/services/Blog'
import find from 'lodash/find'
import Logger from '@/services/Logger'
/* import { slugify } from '@/helpers' */

/* function deepCategories (categories, parentPath = '') {
  let flatCategories = []
  for (var i in categories) {
    categories[i].url_path = parentPath + slugify(categories[i].name)
    flatCategories.push(categories[i])
    flatCategories = flatCategories.concat(deepCategories(categories[i].childrenData, categories[i].url_path + '/'))
  }
  return flatCategories
} */
const ExtractAttributes = ['url_path']
const storeViewCodeRegex = /(({)+(storeViewCode)(})+)|(store_view_code)/g
function decoratorCategory (cat) {
  let tmpAttr
  ExtractAttributes.forEach(attrKey => {
    if (cat.custom_attributes) {
      tmpAttr = cat.custom_attributes.find(item => item.attribute_code === attrKey)
      cat[attrKey] = tmpAttr ? tmpAttr.value : undefined
    }
  })
}

function extendChildCategory (child, parent) {
  const metaKeyworld = find(child.custom_attributes, { attribute_code: 'meta_keywords' })
  if (metaKeyworld && metaKeyworld.value.includes('{link_parent}')) {
    child.url_path = parent.url_path
  }
}
function recursiveBuildTree (currentCategory, categories) {
  let childrenIds, child, tmp, tmpCat
  currentCategory.childrenAllIds = []
  if (currentCategory.is_active) {
    Vue.set(currentCategory, 'childrenData', [])
    childrenIds = currentCategory.children ? currentCategory.children.split(',') : []
    currentCategory.childrenAllIds = childrenIds.length ? [...childrenIds] : []
    childrenIds.forEach(childId => {
      child = categories.find(item => item.id === parseInt(childId))
      if (child.is_active) {
        tmp = recursiveBuildTree(child, categories)
        currentCategory.childrenAllIds = currentCategory.childrenAllIds.concat(tmp.childrenAllIds)
        extendChildCategory(tmp, currentCategory)
        currentCategory.childrenData.push(
          tmp
        )
      }
    })
    // extend all childids
    tmpCat = categories.find(item => item.id === parseInt(currentCategory.id))
    tmpCat.childrenAllIds = currentCategory.childrenAllIds.join(',')
  }
  return currentCategory
}
function createTree (firstCategory, categories) {
  let tree = null
  if (firstCategory) {
    tree = recursiveBuildTree(firstCategory, categories)
  }
  return tree
}

// USED IN FF TO PREVENT CREATION OF SUBTREE WITH ONE CHILD
// function removeIfOneChild (categories) {
//   categories.forEach((cat, index) => {
//     if (cat.childrenData.length === 1) {
//       categories[index].url_path = cat.childrenData[0].url_path
//       cat.childrenData = []
//     }
//   })
// }

let listStoreView = null
export default {
  load (ctx) {
    if (listStoreView === null) {
      listStoreView = ctx.rootState.ui.storeViewCode
    }
    if (!process.client) {
      listStoreView = null
    }
    if (ctx.state.list.length && listStoreView === ctx.rootState.ui.storeViewCode) {
      return Promise.resolve(ctx.state.list)
    }
    Logger.debug('start load category -->', ctx.rootState.ui.storeViewCode, ctx.rootState.ui.dateTime)
    const rootCategoryID = ctx.rootGetters['storeConfig/rootCategoryId']
    // Add search criteria for all categories
    let searchCriteria = `searchCriteria[filter_groups][0][filters][0][field]=path&searchCriteria[filter_groups][0][filters][0][value]=%25${rootCategoryID}%25&searchCriteria[filter_groups][0][filters][0][condition_type]=like`
    let query = Config.API.catalog.categories.replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode).replace('searchCriteria', searchCriteria)
    return restWithCache({
      query,
      restPromise: HttpProvider.get(query, {
        headers: {
          'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`
        }
      })
    })
      .then(category => {
        Logger.debug('load category -->', ctx.rootState.ui.storeViewCode, ctx.rootState.ui.dateTime)
        category = JSON.parse(JSON.stringify(category).replace(storeViewCodeRegex, ctx.rootState.ui.storeViewCode))
        // blog decorator
        return Blog.decorateCategories(
          category,
          ctx.rootState.user.token,
          ctx.rootState.ui.storeViewCode
        )
      })
      .then(category => {
        // create flatted categories
        // const flattedCategories = deepCategories(category.items)
        ctx.commit('saveFlatted', category.items)
        category.items.forEach(child => {
          decoratorCategory(child)
        })
        let categoryTree = createTree(category.items.find(item => item.id === rootCategoryID), category.items)

        // removeIfOneChild(categoryTree.childrenData)
        ctx.commit('saveList', categoryTree.childrenData)
        ctx.commit('saveRoot', categoryTree)
        listStoreView = ctx.rootState.ui.storeViewCode

        return categoryTree.childrenData
      })
  }
}
